import { Component, Input, ElementRef } from '@angular/core';

import * as _ from 'lodash';

@Component({
  selector: 'uex-list',
  templateUrl: './list.component.html',
  host: {
    class: 'uex-list list-group',

    '[class.list-group-borderless]': 'borderless',
    '[class.list-group-flush]': 'flush',

    '[class.list-group-horizontal]': 'horizontal == \'xs\'',
    '[class.list-group-horizontal-sm]': 'horizontal == \'sm\'',
    '[class.list-group-horizontal-md]': 'horizontal == \'md\'',
    '[class.list-group-horizontal-lg]': 'horizontal == \'lg\'',
    '[class.list-group-horizontal-xl]': 'horizontal == \'xl\'',

    '[style.max-height.px]': 'dynamicScroll',
    '[style.height.px]': 'scroll',
    '[style.overflow-x]': 'dynamicScroll || scroll ? \'auto\' : \'\''
  }
})
export class ListComponent {
  @Input('borderless') private set _setBorderless(borderless: boolean) {
    this.borderless = this._getAttribute(borderless, true);
  }
  @Input('clickable') private set _setClickable(clickable: boolean) {
    this.clickable = this._getAttribute(clickable, true);
  }
  @Input('flush') private set _setFlush(flush: boolean) {
    this.flush = this._getAttribute(flush, true);
  }
  @Input('hover') private set _setHover(hover: boolean) {
    this.hover = this._getAttribute(hover, true);
  }
  @Input('scroll') set _scroll(scroll_height: number) {
    setTimeout(() => this.scroll = scroll_height || null, 100);
  }
  @Input('dynamicScroll') set _dynamicScroll(scroll_height: number) {
    setTimeout(() => this.dynamicScroll = scroll_height || null, 100);
  }

  @Input('horizontal') set _horizontal(horizontal: boolean | 'xs' | 'sm' | 'md' | 'lg' | 'xl') {
    if (_.isString(horizontal) || _.isBoolean(horizontal)) {
      if (_.isEmpty(horizontal) || (_.isBoolean(horizontal) && horizontal)) { horizontal = 'xs'; }
      this.horizontal = horizontal;
    } else {
      this.horizontal = false;
    }
  }

  constructor(
    public elementRef: ElementRef
  ) { }

  public borderless = false;
  public clickable = false;
  public flush = false;
  public hover = false;

  public horizontal: boolean | 'xs' | 'sm' | 'md' | 'lg' | 'xl' = false;

  public scroll: number;
  public dynamicScroll: number;

  public get offsetTop(): number {
    return this.elementRef.nativeElement.offsetTop;
  }

  public scrollTo(offset: number) {
    if (this.hasScroll()) { this.elementRef.nativeElement.scrollTop = offset; }
  }

  public scrollToTop() {
    if (this.hasScroll()) { this.elementRef.nativeElement.scrollTop = 0; }
  }

  public scrollToBottom() {
    if (this.hasScroll()) { this.elementRef.nativeElement.scrollTop = this.elementRef.nativeElement.scrollHeight; }
  }

  public hasScroll() {
    if (this.scroll || this.dynamicScroll) {
      const el = this.elementRef.nativeElement;
      const ul = this.elementRef.nativeElement.childNodes[0];
      return ul.offsetHeight > el.offsetHeight;
    }
    return false;
  }

  private _getAttribute(value: any, boolean: boolean = false): any {
    if (boolean) { return (_.isString(value) && value !== 'false') || (_.isBoolean(value) && !!value); }
    return !!value ? value : null;
  }
}
